import React, { useEffect, useState} from 'react';
import { Routes, Route} from 'react-router-dom';
import { Amplify, Auth, Hub } from 'aws-amplify';
import awsExports from './aws-exports';
import './App.css';
import Login from './components/auth/Login.js';
import Home from './components/home/home.js';
import FacultyReports from './components/facultyReports/facultyReports.js';
import CertificateReports from './components/certificateReports/certificateReports.js';
import { getFacultyDocIdFromEmployeeNumber } from './utils/CertificateReportsDataApi.js';
import * as AuthConstants from './data/AuthConstants.js';
import { ClipLoader } from 'react-spinners';
import { getPortalAccessStatus } from './utils/CertificatePortalAccessController.js';
import { PARAMETER_LOCK_VALUE } from './data/CertificatePortalAccessConstants.js';

Amplify.configure(awsExports);

function App() {
    const [user, setUser] = useState(null);
    const [portalAccessStatus, setPortalAccessStatus] = useState(null);
    const [loadingUser, setLoadingUser] = useState(false);

    const isAccessLocked = () => {
        return portalAccessStatus.value === PARAMETER_LOCK_VALUE && !user.isAdminRol;
    }

    useEffect(() => {
        const unsubscribe = Hub.listen(AuthConstants.AUTH_EVENT_NAME, ({ payload: { event, data }}) => {
            switch (event) {
                case "signIn":
                    setUser(data);
                    break;
                case "signOut":
                    setUser(null);
                    break;
                case "customOAuthState":
                    break;
                case 'signIn_failure':
                    console.error(data);
                    break;
                default:
            }
        });

        getUser();

        return unsubscribe;
    }, []);

    const getUser = async (): Promise<void> => {
        try {
            setLoadingUser(true);
            const currentUser = await Auth.currentAuthenticatedUser({bypassCache: true});
            if(currentUser && currentUser.signInUserSession.idToken.payload){
                var userId = currentUser.signInUserSession.idToken.payload.identities[0].userId;
                var userDocId = '';
                const isAdminRol = currentUser.signInUserSession.idToken.payload['custom:Rol'].includes(AuthConstants.AUTH_ADMIN_IDENTITY_GROUP_ID);
                if(!isAdminRol){
                    userDocId = await getFacultyDocIdFromEmployeeNumber(userId);
                }

                setUser(() => ({
                    userId: userId,
                    userName: currentUser.signInUserSession.idToken.payload['cognito:username'],
                    email: currentUser.signInUserSession.idToken.payload['email'],
                    givenName: currentUser.signInUserSession.idToken.payload['given_name'],
                    middleName: currentUser.signInUserSession.idToken.payload['middle_name'],
                    isAdminRol: isAdminRol,
                    rol: isAdminRol ? 'Administrador': 'Profesor',
                    userDocId: userDocId,
                    codProf: userId
                }));

                const accessStatus = await getPortalAccessStatus();
                setPortalAccessStatus(accessStatus);
            }
        } catch(error) {
            console.error(error);
        } finally {
            setLoadingUser(false);
        }
    };

    Auth.configure({
        oauth: {
            ...Auth.configure().oauth,
            redirectSignIn: window.location.origin + '/home',
            redirectSignOut: window.location.origin + '/',
            clientId: AuthConstants.AUTH_CLIENT_ID,
            responseType: AuthConstants.AUTH_CONFIG_RESPONSE_TYPE,
            scope: AuthConstants.AUTH_CONFIG_SCOPE
        },
    });

    return (
        <div className='container'>
        { (loadingUser) ? (
            <div>
                <div className="spinner-container">
                    <ClipLoader color="red" loading={loadingUser} size={50} />
                </div>
            </div>
        ) : (
            <Routes>
                <Route path='*' element={<Login/>}/>
                <Route path='/' element={<Login/>}/>
                {user ? <Route path='/home' element={<Home user={user} accessStatus={portalAccessStatus} acessStatusHandler={setPortalAccessStatus} />}/> : null}
                {user ? <Route path='/certificateReports' element={<CertificateReports user={user}/>}/> : null}
                {user ? <Route path='/facultyReports' element={<FacultyReports user={user}/>}/> : null}
                <Route path='/signout' element={<Login/>} />
            </Routes>
        )}
        </div>
    )
}

export default App;
